import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, ShoppingBag, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { useAuth } from "@/lib/auth";

export const KitLock = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [kit, setKit] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/products", { params: { is_hamper: true } })
      .then(({ data }) => setKit(data.find((p) => p.sku === "HMP-JOINING-7200") || data[0] || null))
      .catch(() => {});
  }, []);

  const pay = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/mlm/businesses/${user.id}/pay-kit`);
      navigate(`/checkout/direct/${data.order_id}`);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Could not start checkout");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-xl mx-auto mt-6 bg-white rounded-3xl border border-[#FEE2E2] shadow-sm p-8 text-center" data-testid="kit-lock-screen">
      <div className="w-14 h-14 mx-auto rounded-full bg-[#FEE2E2] flex items-center justify-center mb-4">
        <Lock className="w-6 h-6 text-[#DC2626]" />
      </div>
      <h1 className="font-display text-2xl font-bold text-[#7F1D1D]">Activate your account</h1>
      <p className="text-sm text-[#64748B] mt-2">
        Purchase the {kit?.name || "EverGro Premium Hamper"} to unlock your member dashboard.
        If you have already been approved by the admin, please contact support.
      </p>
      {kit && (
        <div className="mt-6 flex items-center gap-4 text-left border border-[#E2E8F0] rounded-2xl p-4">
          {kit.images?.[0] && <img src={kit.images[0]} alt={kit.name} className="w-20 h-20 rounded-xl object-cover" />}
          <div>
            <div className="font-semibold text-[#7F1D1D]">{kit.name}</div>
            <div className="font-numbers text-xl font-bold text-[#DC2626]" data-testid="kit-lock-price">₹{Number(kit.price).toLocaleString("en-IN")}</div>
          </div>
        </div>
      )}
      <button onClick={pay} disabled={busy} className="btn-primary mt-6 w-full inline-flex items-center justify-center gap-2" data-testid="kit-lock-pay-btn">
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <ShoppingBag className="w-4 h-4" />} Buy hamper & activate
      </button>
      <button onClick={() => navigate("/orders")} className="mt-3 text-sm text-[#B91C1C] underline" data-testid="kit-lock-orders-link">View my orders / payment status</button>
    </div>
  );
};
